import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { BAlert } from 'bootstrap-vue-next';

export default /*@__PURE__*/_defineComponent({
  __name: 'TaskResultState',
  props: {
    error: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BAlert), {
    "model-value": !!__props.error,
    variant: "danger"
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(__props.error), 1)
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})